import axios from "axios";

function joinBase(base, path) {
  if (!base) return path;
  const trimmedBase = base.replace(/\/+$/, "");
  const trimmedPath = path.startsWith("/") ? path : `/${path}`;
  return `${trimmedBase}${trimmedPath}`;
}

export default function createClient(baseURL) {
  const apiBase = process.env.REACT_APP_API_BASE || "";
  const resolvedBase = joinBase(apiBase, baseURL);

  const api = axios.create({
    baseURL: resolvedBase,
    headers: { "Content-Type": "application/json" },
  });

  api.interceptors.request.use((config) => {
    const token = localStorage.getItem("byka_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;

    const activeRole = localStorage.getItem("byka_active_role");
    if (activeRole) config.headers["X-Active-Role"] = activeRole;

    return config;
  });

  api.interceptors.response.use(
    (r) => r,
    (err) => {
      if (
        err.response?.status === 401 &&
        !err.config?.url?.endsWith("/auth/login")
      ) {
        localStorage.removeItem("byka_token");
        const base = process.env.PUBLIC_URL || "";
        window.location.href = base + "/login";
      }

      // Normalize error messages globally
      let errorMessage = "An unexpected error occurred.";

      if (!err.response) {
        // Network error / CORS / Server offline
        errorMessage =
          "Unable to connect to the server. Please check your internet connection.";
      } else if (err.response.data?.error) {
        // Our backend API standard: { error: "Message" }
        errorMessage = err.response.data.error;
      } else if (
        typeof err.response.data === "string" &&
        err.response.data.trim() !== ""
      ) {
        // Catch-all for plain text errors (e.g. 502 Bad Gateway from reverse proxy)
        errorMessage = err.response.data;
      } else if (err.message) {
        // Fallback to Axios internal message if nothing else is available
        errorMessage = err.message;
      }

      const normalizedError = new Error(errorMessage);
      normalizedError.status = err.response?.status;
      normalizedError.originalError = err;

      return Promise.reject(normalizedError);
    },
  );

  return api;
}
